import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

const InvitationIntro = () => {
  const {i18n} = useTranslation();
  const img1 = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/invitation/invite-pic-1-bn.webp')
      : require('@/assets/imgs/invitation/invite-pic-1.webp');
  }, [i18n.language]);
  const img2 = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/invitation/invite-pic-2-bn.webp')
      : require('@/assets/imgs/invitation/invite-pic-2.webp');
  }, [i18n.language]);
  const img3 = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/invitation/invite-pic-3-bn.webp')
      : require('@/assets/imgs/invitation/invite-pic-3.webp');
  }, [i18n.language]);
  return (
    <div className="flex flex-col">
      <div
        className="w-[23.4375rem] h-[44.8125rem] bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${img1})`,
        }}
      />
      <div
        className="w-[23.4375rem] h-[62.0625rem] bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${img2})`,
        }}
      />
      <div
        className="w-[23.4375rem] h-[67.1875rem] bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${img3})`,
        }}
      />
    </div>
  );
};

export default InvitationIntro;
